// Third-party packages
import {
	APP_CONF_VARS,
} from '@appConf/vars.conf';
import {
	GetCompanyBuildingListError,
} from '@exceptions/GetCompanyBuildingListError';
import {
	GetCompanyInformationError,
} from '@exceptions/GetCompanyInformationError';
import {
	GetCompanyManagersError,
} from '@exceptions/GetCompanyManagersError';
import {
	getURL,
} from '@modules/utils';
import {
	FETCHES,
} from '@routes/fetches';

// Project modules
import {
	GetCompanyBuildingListApiResponse,
} from '@localTypes/companyBuildings';
import {
	GetCompanyManagersApiResponse,
} from '@localTypes/companyManagers';

// Relative imports
import {
	customFetcher,
} from './custom-fetch';

interface RequestOptions {
	accessToken: string;
	companyId: number;
	pageNumber?: number;
	pageSize?: number;
	sortBy?: string;
	sortOrder?: string;
}

export const getInformation = async (options: RequestOptions): Promise<any> => {
	const {
		accessToken,
		companyId,
	} = options;

	return await customFetcher(getURL(FETCHES.private.companies.id, {
		':companyid': `${companyId}`,
	}), {
		...APP_CONF_VARS.request.default,
		headers: {
			...APP_CONF_VARS.request.default.headers,
			'Authorization': `Bearer ${accessToken}`,
		},
	}).then((resp) => resp.json()).catch(error => {
		throw new GetCompanyInformationError(error);
	});
};

export const getCompanyManagers = async (options: RequestOptions): Promise<GetCompanyManagersApiResponse> => {
	const {
		accessToken,
		companyId,
		pageNumber,
		pageSize,
		sortBy,
		sortOrder,
	} = options;

	return await customFetcher(getURL(FETCHES.private.companies.managers, {
		':companyid': `${companyId}`,
		':page_number': `${pageNumber}`,
		':page_size': `${pageSize}`,
		':sort_by': `${sortBy}`,
		':sort_order': `${sortOrder}`,
	}), {
		...APP_CONF_VARS.request.default,
		headers: {
			...APP_CONF_VARS.request.default.headers,
			'Authorization': `Bearer ${accessToken}`,
		},
	}).then((resp) => resp.json()).catch(error => {
		throw new GetCompanyManagersError(error);
	});
};

export const getCompanyEvents = async (options: {
	companyId: number,
	page: number,
	size: number,
	sort: string,
}): Promise<any> => {
	const {
		// accessToken,
		// companyId,
		// page,
		// size,
		// sort,
	} = options;
	return Promise.resolve({
		results: [],
		status: 200,
		total: 0,
	});
	// return await customFetcher(getURL(FETCHES.private.companies.events, {
	// 	':companyid': `${companyId}`,
	// 	'page': `${page}`,
	// 	'size': `${size}`,
	// 	'sort': `${sort}`,
	// }), {
	// 	...APP_CONF_VARS.request.default,
	// }).then((resp) => resp.json()).catch(error => {
	// 	throw new GetCompanyOfficersError(error);
	// });
};

export const getCompanyBuildingList = async (options: RequestOptions): Promise<GetCompanyBuildingListApiResponse> => {
	const {
		accessToken,
		companyId,
		pageNumber,
		pageSize,
		sortBy,
		sortOrder,
	} = options;

	return await customFetcher(getURL(FETCHES.private.companies.buildings, {
		':companyid': `${companyId}`,
		':page_number': `${pageNumber}`,
		':page_size': `${pageSize}`,
		':sort_by': `${sortBy}`,
		':sort_order': `${sortOrder}`,
	}), {
		...APP_CONF_VARS.request.default,
		headers: {
			...APP_CONF_VARS.request.default.headers,
			'Authorization': `Bearer ${accessToken}`,
		},
	}).then((resp) => resp.json()).catch(error => {
		throw new GetCompanyBuildingListError(error);
	});
};

export const getCompanyEstablishments = async (options: {
	companyId: number,
}): Promise<any> => {
	const {
		// accessToken,
		// companyId,
		// page,
		// size,
		// sort,
	} = options;
	return Promise.resolve({
		results: [],
		status: 200,
		total: 0,
	});
};

export const getCompanyTransactions = async (options: {
	companyId: number,
}): Promise<any> => {
	const {
		// accessToken,
		// companyId,
		// page,
		// size,
		// sort,
	} = options;
	return Promise.resolve({
		results: [],
		status: 200,
		total: 0,
	});
};

export const getCompanyLands = async (options: {
	companyId: number,
}): Promise<any> => {
	const {
		// accessToken,
		// companyId,
		// page,
		// size,
		// sort,
	} = options;
	return Promise.resolve({
		results: [],
		status: 200,
		total: 0,
	});
};